import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { Popup, Menu, Icon } from 'semantic-ui-react'

class ProfileContainer extends Component {
  render() {
    let { user } = this.props

    let popupContent = (
      <div className="app-menu-profile-popup">
        <Link to="/logout">
          <Icon name="log out" />
          Kirjaudu ulos
        </Link>
      </div>
    )

    return (
      <div className="app-menu-profile">
        <Popup
          trigger={<button className="app-menu-profile-button">{user.email}</button>}
          content={popupContent}
          style={{ marginRight: '10px', marginTop: 0, padding: 0, borderRadius: 0 }}
          on="click"
          position="bottom right"
        />
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    user: state.authUser,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    myAction: () => dispatch(myAction()),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProfileContainer)
